import { render, staticRenderFns } from "./ReasonCancellation.vue?vue&type=template&id=22860f6a&scoped=true&"
import script from "./ReasonCancellation.vue?vue&type=script&lang=js&"
export * from "./ReasonCancellation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22860f6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22860f6a')) {
      api.createRecord('22860f6a', component.options)
    } else {
      api.reload('22860f6a', component.options)
    }
    module.hot.accept("./ReasonCancellation.vue?vue&type=template&id=22860f6a&scoped=true&", function () {
      api.rerender('22860f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Invoices/History/ReasonCancellation.vue"
export default component.exports